function* configurationSaga(): any {

}

export default configurationSaga;
